export default __webpack_public_path__ + "static/media/huma-yocto-00.441a4c71.jpg";